const ITEMS = [
    "International Recruitment",
    "Manpower Solutions",
    "Global Mobility",
    "Study Abroad",
    "Visa Assistance",
    "Nigeria • USA",
];

export const TrustStrip = () => (
    <div
        data-testid="trust-strip"
        className="overflow-hidden border-b border-ink/10 bg-ivory py-5"
        aria-label="Core services: International Recruitment, Manpower Solutions, Global Mobility, Study Abroad, Visa Assistance — Nigeria and USA"
    >
        <div className="marquee-track flex w-max items-center">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <span
                    key={i}
                    aria-hidden={i >= ITEMS.length}
                    className="flex items-center whitespace-nowrap text-[11px] font-medium uppercase tracking-[0.32em] text-ink/65"
                >
                    <span className="px-8">{item}</span>
                    <span className="h-1.5 w-1.5 rotate-45 bg-champagne/70" aria-hidden="true" />
                </span>
            ))}
        </div>
    </div>
);
